import { startPollingMessages } from './startPollingMessages';
import { IOfferReaction } from '../../repositories/cian-chat-bot/entities/offer_reaction/OfferReaction';
import { chatbotSetOfferReaction } from '../../services/chatbotSetOfferReaction';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';

export const applyOfferReaction =
  (params: IOfferReaction): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const result = await chatbotSetOfferReaction({ httpApi, logger }, params);

    if (!result) {
      dispatch(showAlert({ message: 'Сервисная ошибка. Попробуйте позже.' }));

      return;
    }

    dispatch(startPollingMessages());
  };
